import React, { useState, useEffect } from 'react';
import { Row, Col } from 'reactstrap';
import { faBoxes, faCalendar , faEye, faFileAlt, faRunning } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment/moment';
import { useNavigate, useLocation } from 'react-router-dom';

//Components
import InfoCard from '../../../components/InfoCard/InfoCard';
import Loading from 'components/Loading/Loading';
import { useDashboard } from '../../../context/DashboardContext';

//Api
import dashboard_api from '../../../api/dashboard_api';
import { showMessage } from 'helpers/message';

//Estado inicial dos filtros
function initialStateFiltros() {
    const dataInicial = new Date();
    const dataFinal = new Date();
    dataInicial.setDate(dataFinal.getDate() - 30);

    return {
        dataInicial: moment(dataInicial).format("YYYY-MM-DD"),
        dataFinal: moment(dataFinal).format("YYYY-MM-DD"),
    }
}

export default function DashBoardFiscal() {
    const { dadosDashboardProvider, setDadosDashboardProvider } = useDashboard();
    
    //Estado de controle do loading na tela
    const [loading, setLoading] = useState(false);
 
    //Estado de controle dos dados da dashboard
    const [dadosDashboard, setDadosDashboard] = useState({});

    //Variavel de navegação
    const navigate = useNavigate();

    //Variavel para pegar os dados passados na rota
    const location = useLocation();

    //Filtros passados na rota
    const { paramsFiltros } = location.state ? location.state : {};

    //Estado de controle dos valores dos filtros
    const [filtros] = useState(paramsFiltros ? paramsFiltros : initialStateFiltros);
 
    //Função que carrega os dados da dashboard
    const carregaDadosDashboard = () => {
        if(!!dadosDashboardProvider && !!dadosDashboardProvider?.recarregarViaContext){
            setDadosDashboard(dadosDashboardProvider);
            return;
        }  
        
        setLoading(true);
        dashboard_api.GetDashboard().then(response => {
            setDadosDashboard(response.data);
            setDadosDashboardProvider({...response.data, recarregarViaContext: true});
        }).catch(e => {
            showMessage("Aviso!", e.message, "error", null);
        }).finally(f => setLoading(false));
    }

    useEffect(() => {
        carregaDadosDashboard();
    }, []);

    return (
        <div>
            {loading && <Loading />}
            <div className='mx-4 mt-3 d-flex align-items-center justify-content-between'>
                <h4 className="text-dark fw-normal">Painel Geral</h4>
            </div>

            <h5 className='mx-4 mt-2 mb-2'>Vistorias</h5>
            <Row className='mt-2'>

                <Col lg="4" md="12" className='px-4 mt-2'>
                    <InfoCard onClick={() => {
                        navigate("/admin/vistorias", { state: { filtros: { status: ["Pendente"] }, titleTable: "Lista de vistorias pendentes", btnVoltar: "/admin/dashboard", filtrosRetorno: filtros } })
                    }} link icon={faEye} title="Vistorias pendentes" specialSubTitle={dadosDashboard.vistoriasPendentes != undefined ? dadosDashboard.vistoriasPendentes.toString() : ""} />
                </Col>
                <Col lg="4" md="12" className='px-4 mt-2'>
                    <InfoCard onClick={() => {
                        navigate("/admin/vistorias", { state: { filtros: { status: ["Agendada"] }, titleTable: "Lista de vistorias agendadas", btnVoltar: "/admin/dashboard", filtrosRetorno: filtros } })
                    }} link icon={faCalendar} title="Vistorias agendadas" specialSubTitle={dadosDashboard.vistoriasAgendadas != undefined ? dadosDashboard.vistoriasAgendadas.toString() : ""} />
                </Col>
                <Col lg="4" md="12" className='px-4 mt-2'>
                    <InfoCard onClick={() => {
                        navigate("/admin/vistorias", { state: { filtros: { status: ["Em Execução"] }, titleTable: "Lista de vistorias em execução", btnVoltar: "/admin/dashboard", filtrosRetorno: filtros } })
                    }} link icon={faRunning} title="Vistorias em processo" specialSubTitle={dadosDashboard.vistoriasEmProcesso != undefined ? dadosDashboard.vistoriasEmProcesso.toString() : ""} />
                </Col>
            </Row>
            <h5 className='mx-4 mt-4'>Grandes Geradores Sem Contrato</h5>
            <h6 className='mx-4 mb-2'>Prazo para regularização</h6>
            <Row className='mt-2'>
                <Col lg="4" md="12" className='px-4 mt-2'>
                    <InfoCard className='cardSuccess' onClick={() => navigate("../grande-gerador-sem-contrato", { state: { btnVoltar: "/admin/dashboard", statusParam: "dentroDoPrazo", titleTable: "Lista de grandes geradores dentro do prazo" } })} link icon={faBoxes} title="Dentro do prazo" specialSubTitle={dadosDashboard.grandesGeradoresDentroDoPrazo != undefined ? dadosDashboard.grandesGeradoresDentroDoPrazo.toString() : ""} />
                </Col>
                <Col lg="4" md="12" className='px-4 mt-2'>
                    <InfoCard className='cardWarning' onClick={() => navigate("../grande-gerador-sem-contrato", { state: { btnVoltar: "/admin/dashboard", statusParam: "50DoPrazo", titleTable: "Lista de grandes geradores com 50% do prazo" } })} link icon={faBoxes} title="50% do prazo" specialSubTitle={dadosDashboard.grandesGeradores50DoPrazo != undefined ? dadosDashboard.grandesGeradores50DoPrazo.toString() : ""} />
                </Col>
                <Col lg="4" md="12" className='px-4 mt-2'>
                    <InfoCard className='cardDanger' onClick={() => navigate("../grande-gerador-sem-contrato", { state: { btnVoltar: "/admin/dashboard", statusParam: "foraDoPrazo", titleTable: "Lista de grandes geradores fora do prazo" } })} link icon={faBoxes} title="Fora do prazo" specialSubTitle={dadosDashboard.grandesGeradoresForaDoPrazo != undefined ? dadosDashboard.grandesGeradoresForaDoPrazo.toString() : ""} />
                </Col>
            </Row>
            <h5 className='mx-4 mt-4'>Notificações</h5>
            <Row className='mt-2 mb-4'>
                <Col lg="4" md="12" className='px-4 mt-2'>
                    <InfoCard onClick={() => navigate("../analise-notificacoes", { state: { btnVoltar: "/admin/dashboard", statusParam: "Prazo excedido", titleTable: "Lista de notificações com prazo excedido" } })} link icon={faFileAlt} title="Prazo excedido" specialSubTitle={dadosDashboard.notificacoesComPrazoExcedido != undefined ? dadosDashboard.notificacoesComPrazoExcedido.toString() : ""} />
                </Col>
                <Col lg="4" md="12" className='px-4 mt-2'>
                    <InfoCard onClick={() => navigate("../analise-notificacoes", { state: { btnVoltar: "/admin/dashboard", tipoNotificacaoParam: "NotificarColetaSemPGRS", titleTable: "Lista de notificações de Coleta sem PGRS" } })} link icon={faFileAlt} title="Notificações de Coleta sem PGRS" specialSubTitle={dadosDashboard?.notificacoesSemPGRS?.length} />
                </Col>
            </Row>
        </div>
    );
}